import styled from 'styled-components';

export const Container = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin: 24px 0;
`;
